<lib-generic-type-ahead-dropdown
    [(selectedItem)]="selectedBuilding"
    [placeholder]="placeholder()"
    (selectedItemChange)="onBuildingChange($event)"
    [displaySelected]="displaySelected"
    [(text)]="searchText"
    [source]="source"
    (textChange)="onBuildingTextChanged()"
    [config]="{
        defaultText: 'Add Building',
        itemDisplayKey: 'name',
        itemTemplate: buildingTemplate,
        isActive: selectedBuilding?.isActive ?? true
    }"
    [isReadOnly]="isReadOnly"
    [action]="addBuildingAction"
    [error]="error"
    [path]="path()"
>
</lib-generic-type-ahead-dropdown>

<ng-template #buildingTemplate let-data>
    @if (!data.object.alternateName) {
        <div>
            <div
                class="title"
                [innerHTML]="$safeNavigationMigration(data.object?.name) | highlightText: data.inputText"
            ></div>
        </div>
    }
    @if (data.object?.alternateName) {
        <div>
            <div
                class="title"
                [innerHTML]="$safeNavigationMigration(data.object?.alternateName) | highlightText: data.inputText"
            ></div>
            <div
                class="subtitle"
                [innerHTML]="$safeNavigationMigration(data.object?.name) | highlightText: data.inputText"
            ></div>
        </div>
    }
</ng-template>
